/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.validation.required\":[\"Mindst én valgt mulighed er påkrævet.\"],\"checkbox-group.label.optional\":[\"Valgfri\"]}");
//# sourceMappingURL=messages.mjs.map